module.exports = __webpack_public_path__ + "static/media/aakash.7378ece2.jpg";